import { emeraldRequest } from '../../common/api/emerald-request';
import { IPagedData } from '../../common/interfaces/dtos/IPagedData';
import { ICustomer } from '../../common/interfaces/dtos/ICustomer';
import { ICustomerSearchCriteria } from '../../common/interfaces/dtos/ICustomerSearchCriteria';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../common/interfaces/requests/EmeraldRequestParams';
import { store } from 'src/common/redux/configure-store';

export const searchCustomersByCriteria = async (
  searchCriteria: Partial<ICustomerSearchCriteria>,
  pageNumber: number,
  pageSize = 5,
): Promise<IPagedData<ICustomer>> => {
  const pagedSearchRequest = {
    searchCriteria: searchCriteria,
    pageStart: pageNumber,
    pageNumber,
    pageSize,
    operator: 'AND',
    touchpointId: store.getState().touchPoint.touchPointConfiguration.touchPointId,
  };
  const axiosConfig: AxiosRequestConfig = {
    url: '/customer/find-by-criteria',
    method: 'POST',
    data: pagedSearchRequest,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoggingInfo: true,
  };
  return emeraldRequest<IPagedData<ICustomer>>(emeraldRequestParams);
};
